import { useSelector } from "react-redux";

import { useIntl } from "react-intl";

import EntityType from "@mapmycustomers/shared/enum/EntityType";
import HasSourceObject from "@mapmycustomers/shared/types/base/HasSourceObject";

import { getSourceObjectValues } from "@app/store/iam";
import { RootState } from "@app/store/rootReducer";
import { getSourceObjectMessageArgs, SourceObjectMessageArgs } from "@app/util/ui";

// Supplies what a component cannot: the current intl and the organization's source objects.
// The rules live in getSourceObjectMessageArgs, which a saga can call with i18nService.getIntl().
const useSourceObjectMessageArgs = (
  entityType: EntityType | undefined,
  key: HasSourceObject["sourceObject"] | undefined
): SourceObjectMessageArgs => {
  const intl = useIntl();
  const values = useSelector((state: RootState) => getSourceObjectValues(state, entityType));
  return getSourceObjectMessageArgs(intl, entityType, values, key);
};

export default useSourceObjectMessageArgs;
